import * as React from "react";
import Container from "@mui/material/Container";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import { useNavigate, useParams } from "react-router-dom";
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import DownloadIcon from "@mui/icons-material/Download";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import truncateStr from "../../utils/truncateString";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from "@mui/material/SvgIcon/SvgIcon";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Portal from "@mui/material/Portal";
import { useContext } from "react";
import { AuthUserContext } from "../../providers/AuthProvider";
import { circularProgressClasses, styled } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Box from "@mui/material/Box/Box";
import Fab from "@mui/material/Fab/Fab";
import ClearIcon from "@mui/icons-material/Clear";
import { CheckCircle } from "@mui/icons-material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PostNotification from "../../helpers/post-notification";
import PostActivity from "../../helpers/post-activity";

export default function NDAComponent() {
	const storageRef = firebase.storage().ref();
	const [open, setOpen] = React.useState(false);
	const [openNDA, setOpenNDA] = React.useState(false);
	const [ndaBool, setNdaBool] = React.useState(false);
	const { user, profile } = useContext(AuthUserContext);
	let { projectId } = useParams();
	const navigator = useNavigate();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const NotNowhandleClose = () => {
		setOpen(false);
	};

	const Input = styled("input")({
		display: "none",
	});
	const [files, setFiles] = React.useState();
	const setFile = (e) => {
		const list = files ? [...files] : [];

		list.push({ file: e.target.files[0], progress: 0 });
		setFiles(list);
	};

	const uploadFile = () => {
		files.forEach((file, i) => {
			if (file.progress === 0) {
				const path = `NDA/${projectId}/${user?.uid}/${file.file.name}`;
				const uploadTask = storageRef.child(path).put(file.file);
				uploadTask.on(
					"state_changed",
					(snapshot) => {
						// Observe state change events such as progress, pause, and resume
						// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
						const progress =
							(snapshot.bytesTransferred / snapshot.totalBytes) *
							100;
						const newState = files;
						newState[i].progress = progress;
						setFiles([...newState]);
						console.log("Upload is " + progress + "% done");
						switch (snapshot.state) {
							case firebase.storage.TaskState.PAUSED: // or 'paused'
								console.log("Upload is paused");
								break;
							case firebase.storage.TaskState.RUNNING: // or 'running'
								console.log("Upload is running");
								break;
						}
					},
					(error) => {},
					() => {
						const newState = files;
						newState[i].progress = 100;
						newState[i].url = path;
						setFiles([...newState]);
						// Handle successful uploads on complete
						// For instance, get the download URL: https://firebasestorage.googleapis.com/...
					}
				);
			} else {
				return file;
			}
		});
	};
	const submitNDA = async () => {
		const ndaRef = firebase.firestore().collection("NDA");
		try {
			await ndaRef.add({
				uid: user.uid,
				createdAt: firebase.firestore.FieldValue.serverTimestamp(),
				signed: true,
				projectId,
				signNdaPath: files[0].url,
				name: profile?.name,
				userType: profile?.userType,
			});
			const projectRef = await firebase
				.firestore()
				.collection("projects")
				.doc(projectId)
				.get();
			const project = { id: projectRef.id, ...projectRef.data() };
			const stateObject = { state: { project, tab: 0 } };
			const postId = await PostNotification({
				title: "A new NDA was signed",
				text: "A new signed NDA is pending approval. Click here to review it.",
				uid: null,
				createdBy: "self",
				showing: ["super"],
				link: "/admin/project-management",
				state: JSON.stringify(stateObject),
			});
			PostActivity({
				text: `You have successfully signed and uploaded the NDA for project "${project.title}"`,
				uid: profile.uid,
				createdBy:profile?.uid
			}).then()
			console.log(`Notify Admin ${postId}`);
			setOpenNDA(true);
			//profile?.userType === 'investor' ? navigator(`/investor/project-milestones/${projectId}`)
			// : navigator(`/artists/project-show-interest/${projectId}`);

			/*TODO: navigate to project details view layer 3*/
		} catch (e) {
			console.log(e);
		}
	};

	const handleCloseNDA = () => {
		setOpenNDA(false);
	};

	const handleGoToDashboard = () => {
		profile?.userType === "investor"
			? navigator("/investor/dashboard")
			: navigator("/artists/dashboard");
	};
	return (
		<React.Fragment>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar showBar={true}/>*/}

			<Container
				maxWidth="fullWidth"
				sx={{ backgroundColor: "#E3E8F0", paddingY: 5 }}>
				<Container maxWidth="lg" sx={{ textAlign: "left" }}>
					<Typography variant={"h4"} sx={{ paddingX: 2 }}>
						Official NDA information
					</Typography>
				</Container>
			</Container>

			<Container maxWidth="lg" sx={{ textAlign: "left", paddingY: 5 }}>
				<Stack
					direction="row"
					justifyContent="flex-start"
					alignItems="flex-start"
					spacing={10}
					sx={{ width: "100%" }}>
					<Stack
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						spacing={7}
						sx={{ paddingX: 2, flex: 1 }}>
						<Typography variant="body1">
							Before moving forward with your application, we need you
							<br /> to read and agree with the following official
							NDA
						</Typography>
						<Button
							startIcon={<DownloadIcon />}
							variant={"outlined"}
							sx={{ borderRadius: "5px" }}
							href={"/assets/nda/NDA.pdf"}
							download>
							NDA
						</Button>

						<Stack
							direction="row"
							justifyContent="flex-start"
							alignItems="center"
							spacing={5}
							sx={{ width: "100%" }}>
							<label
								htmlFor="avidance-contract"
								style={{ width: "100%" }}>
								<Button
									variant={"outlined"}
									sx={{ py: 1.3, borderRadius: 0 }}
									fullWidth
									component={"span"}
									startIcon={<UploadFileIcon />}>
									Upload signed NDA
								</Button>

								<Input
									accept="**/*"
									id="avidance-contract"
									multiple
									type="file"
									onChange={setFile}
								/>
							</label>

							<Button
								variant={"contained"}
								sx={{ py: 1.3, px: 5, borderRadius: 0 }}
								onClick={uploadFile}>
								Upload
							</Button>
						</Stack>

						<Stack
							direction={"column"}
							spacing={3}
							sx={{ my: 2, width: "100%" }}>
							{files &&
								files.length > 0 &&
								files.map((d, i) => (
									<Stack
										key={i}
										direction="row"
										justifyContent="flex-start"
										alignItems="center"
										spacing={2}
										sx={{
											borderBottom: "1px solid #204488",
											paddingY: 2,
										}}>
										<Stack
											direction="row"
											justifyContent="flex-start"
											alignItems="center"
											spacing={2}
											sx={{ flex: 1 }}>
											{d.progress > 0 &&
											d.progress < 100 ? (
												<CircularProgress
													variant="indeterminate"
													disableShrink
													sx={{
														animationDuration:
															"550ms",
														left: 0,
														[`& .${circularProgressClasses.circle}`]:
															{
																strokeLinecap:
																	"round",
															},
													}}
													size={30}
													thickness={4}
												/>
											) : 
											<>
												{d.progress === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
												{(!d.progress) && 
																<img
																src="/assets/icons/file-upload.png"
																style={{ height: 20, width: 20 }}
																alt=""
																/>
												}
											</>
											}

											<Typography color={"primary"}>
												{d.file.name.length > 10
													? truncateStr(
															d.file.name,
															20
													  )
													: d.file.name}
											</Typography>
										</Stack>
										<Box
											sx={{
												paddingX: 2,
												borderRight: "1px solid #ccc",
											}}>
											<Box
												sx={{
													p: 1,
													background: "#204488",
													fontSize: "small",
													color: "#fff",
												}}>
												{(
													d.file.size /
													1024 /
													1024
												).toFixed(0) == 0
													? (
															d.file.size / 1024
													  ).toFixed(0) + " KB"
													: (
															d.file.size /
															1024 /
															1024
													  ).toFixed(0) + " MB"}
											</Box>
										</Box>
										<Fab
											color={"primary"}
											sx={{ boxShadow: "none" }}
											size={"small"}
											aria-label="delete"
											onClick={() => {
												setFiles([
													...files.slice(0, i),
													...files.slice(
														i + 1,
														files.length
													),
												]);
											}}>
											<ClearIcon />
										</Fab>
									</Stack>
								))}
						</Stack>

						<FormControlLabel
							sx={{ position: "relative", left: -10 }}
							value={ndaBool}
							onChange={(e) => setNdaBool(e.target?.checked)}
							control={<Checkbox />}
							label={
								<Typography variant={"body2"}>
									I can confirm that I have read and agree
									with the NDA.
								</Typography>
							}
						/>
					</Stack>
					<Stack
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						sx={{ width: 300, backgroundColor: "#E3E8F0", p: 2 }}
						spacing={1}>
						<Stack
							direction="row"
							justifyContent="flex-start"
							alignItems="center"
							sx={{ width: "100%" }}>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{ flex: 1 }}>
								What is an NDA?
							</Typography>
							<HelpOutlineIcon />
						</Stack>

						<Typography variant="body2">
							A non-disclosure agreement is a legally binding
							contract that establishes a confidential
							relationship. The party or parties signing the
							agreement agree that sensitive information they may
							obtain will not be made available to any others.
						</Typography>
					</Stack>
				</Stack>
				<Stack
					direction="row"
					justifyContent="center"
					alignItems="center"
					sx={{ width: "100%", marginY: 10 }}>
					<Button
						variant={"contained"}
						color={"primary"}
						sx={{ paddingX: 4 }}
						onClick={() =>
							!ndaBool ? setOpen(true) : submitNDA()
						}>
						Continue
					</Button>

					<Portal>
						<Dialog
							open={open}
							onClose={handleClose}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description">
							<DialogTitle id="alert-dialog-title">
								<Stack direction={"row"} spacing={2}>
									<Typography variant={"h6"} sx={{ flex: 1 }}>
										You cannot move forward{" "}
									</Typography>
									<IconButton
										sx={{ color: "rgba(0, 0, 0, 0.87)" }}
										onClick={() => setOpen(false)}>
										<CloseIcon />
									</IconButton>
								</Stack>
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									<Typography variant={"body2"}>
										Without agreeing with the NDA, you
										cannot move forward. Would you like to
										select another project ?
									</Typography>
								</DialogContentText>
							</DialogContent>
							<DialogActions sx={{ paddingX: 3, paddingY: 2 }}>
								<Button
									onClick={NotNowhandleClose}
									size={"small"}
									sx={{ color: "#000", paddingX: 3 }}>
									Not Now
								</Button>
								<Button
									variant={"contained"}
									color={"warning"}
									sx={{ paddingX: 3 }}
									size={"small"}
									onClick={() => {
										navigator(-2);
									}}>
									Go to dashboard
								</Button>
							</DialogActions>
						</Dialog>

						<Dialog
							open={openNDA}
							onClose={handleCloseNDA}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description">
							<DialogTitle id="alert-dialog-title">
								<Stack direction={"row"} spacing={2}>
									<Typography variant={"h6"} sx={{ flex: 1 }}>
										The next step{" "}
									</Typography>
									<IconButton
										sx={{ color: "rgba(0, 0, 0, 0.87)" }}
										onClick={() => setOpenNDA(false)}>
										<CloseIcon />
									</IconButton>
								</Stack>
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									<Typography variant={"body2"}>
										We will notify you when the NDA is
										verified by the admin. Please note that
										this can take upto 2 weeks.
									</Typography>
								</DialogContentText>
							</DialogContent>
							<DialogActions sx={{ paddingX: 3, paddingY: 2 }}>
								<Button
									variant={"contained"}
									color={"warning"}
									sx={{ paddingX: 3 }}
									size={"small"}
									onClick={handleGoToDashboard}>
									Go to dashboard
								</Button>
							</DialogActions>
						</Dialog>
					</Portal>
				</Stack>
			</Container>
		</React.Fragment>
	);
}
